import AddCircleIcon from '@material-ui/icons/AddCircle'
import SearchIcon from '@material-ui/icons/Search'
import {
    Button,
    Container,
    createStyles,
    FormControl,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Theme
} from '@material-ui/core'
import s from './ContractHistory.module.scss'

import CasesTable, {SearchData} from '../shared/CasesTable/CasesTable'
import { NavLink } from 'react-router-dom'
import {useRef, useState} from 'react'
import getCookie from "../../scripts/getCookie"

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            width: 200,
            [theme.breakpoints.down('xs')]: {
                width: "100%",
                marginRight: 0
            }
        },
        navFilters: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            margin: "30px 0",
            gap: 20,
            "& > div": {
                display: "flex",
                flexDirection: "row",
                gap: 20
            }
        },
        searchField: {
            width: 200,
            [theme.breakpoints.down('xs')]: {
                width: "100%",
                marginRight: 0
            }
        },
        btn: {
            display: "block",
            margin: "15px auto",
            "&:hover": {
                border: "1px solid #3062A0"
            }
        },
    }),
);


export default function ContractHistory() {
    const classes = useStyles()
    const [caseId, setCaseId] = useState<string>("")
    const [client, setClient] = useState<string>("")
    const [attorney, setAttorney] = useState<string>("")
    const [lawFirm, setLawFirm] = useState<string>("")
    const [searchData, setSearchData] = useState<SearchData>({
        caseId: "",
        client: "",
        attorney: "",
        lawFirm: "",
    })
    const currentUserRole = getCookie("currentUserRole")

    const submitSearch = () => {
        setSearchData({
            caseId,
            client,
            attorney,
            lawFirm,
        })
    }

    const resetSearch = () => {
        setCaseId('')
        setClient('')
        setAttorney('')
        setLawFirm('')
        setSearchData({
            caseId: '',
            client: '',
            attorney: '',
            lawFirm: '',
        })
    }

    return (
        <Container maxWidth="lg" className={s["ContractHistory"]} >
            {
                (currentUserRole === "Administrator" || currentUserRole === "Attorney") ?
                <div className={s["ContractHistory-Panel"]} style={{ justifyContent: 'flex-end'}}>
                    <NavLink to="/create-contract-attorney" className={s["ContractHistory-CreateNewRequest"]}>
                        <AddCircleIcon className="PrimaryIcon" />
                        <button>Create New Request</button>
                    </NavLink>
                </div> : ''
            }
            <div className={classes.navFilters}>
                <div>
                    <label className={classes.formControl}>
                        <TextField className={classes.formControl} label="Case ID" value={caseId} type="text" onChange={(e) => setCaseId(e.target.value + "")} />
                    </label>
                    <label className={classes.formControl}>
                        <TextField className={classes.formControl} label="Client" value={client} type="text" onChange={(e) => setClient(e.target.value + "")} />
                    </label>
                    <label className={classes.formControl}>
                        <TextField className={classes.formControl} label="Attorney" value={attorney} type="text" onChange={(e) => setAttorney(e.target.value + "")} />
                    </label>
                    <label className={classes.formControl}>
                        <TextField className={classes.formControl} label="Law Firm" value={lawFirm} type="text" onChange={(e) => setLawFirm(e.target.value + "")} />
                    </label>
                </div>
                <div>
                    <Button color="secondary" variant="outlined" className={classes.btn} onClick={resetSearch}>
                        Reset
                    </Button>

                    <Button color="primary" variant="contained" className={classes.btn} onClick={submitSearch}>
                        Filter
                    </Button>
                </div>
            </div>

            <CasesTable searchData={searchData} />
        </Container>
    );
}
